export const COLUMN_WIDTHS = {
    searchTerm: '20%',
    gallery: '20%',
    culture: '15%',
    sampleSize: '15%',
    scoredEntities: '15%',
    createdBy: '15%',
} as const;

export const COLUMN_HEADERS = {
    searchTerm: 'Keyword',
    gallery: 'Gallery',
    culture: 'Culture',
    sampleSize: 'Sample Size',
    scoredEntities: 'Scored Entities',
    createdBy: 'Created By',
} as const;
